/// <reference path="../types/global.d.ts" />
import React, { useEffect } from 'react'
import {
    // BrowserRouter as RouterProvider,
    HashRouter as RouterProvider,
} from 'react-router-dom'
import { AliveScope } from 'react-activation'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider } from './components/Auth'

import Router, { RouterBeforeEach } from './router'
import applyVConsole from './debug'
import useThemeChange from '@/common/hooks/useThemeChange'

function App() {
    useThemeChange()

    useEffect(() => {
        return applyVConsole()
    }, [])

    return (
        <ErrorBoundary>
            <AliveScope>
                <RouterProvider>
                    <AuthProvider>
                        <Router />
                        <RouterBeforeEach />
                    </AuthProvider>
                </RouterProvider>
            </AliveScope>
        </ErrorBoundary>
    )
}

export default App
